import * as moment from 'moment';

export function inputFormattedDate(type: string, value: any) {
  if (value) {
    if (value instanceof Date) {
      value = value.toISOString();
    }
    //console.log(value + type);

    if (type === 'datetime-local') {
      return value.slice(0, 16);
    } else if (type === 'date') {
      return value.slice(0, 10);
    } else if (type === 'month') {
      return value.slice(0, 7);
    }
  }
  return value;
}

export type LastDateType = 'year' | 'month' | '6months' | '24hours' | 'hour' | '7days' | '10min' | 'yesterday' | 'today' | 'custom' | '12hours';

export function lastDateFunc(name, Timezone_GMT?, DB_BRDiff?) {
  //debugger
  let value = getLastDate(name, Timezone_GMT, DB_BRDiff);//inputFormattedDate(this.column.type, getLastDate(name).toISOString());
  let dt: Date = new Date();
  let yestOrTodayNameTo = name;
  if (name === 'yesterday') {
    dt = new Date(Date.now() + -1 * 24 * 3600 * 1000);
    yestOrTodayNameTo = name + 'To';
  }
  else if (name === 'today') {
    yestOrTodayNameTo = name + 'To';
  }
  let valueTo = formatDate(dt, Timezone_GMT, DB_BRDiff, yestOrTodayNameTo);

  return value + "^" + valueTo;
}

export function getLastDate(type: LastDateType, Timezone_GMT, DB_BRDiff) {
  let dt: Date;
  //debugger
  if (type === 'year') {
    dt = new Date();
    dt.setMonth(dt.getMonth() - 12);
  } else if (type === 'month') {
    dt = new Date();
    dt.setMonth(dt.getMonth() - 1);
  } else if (type === '6months') {
    dt = new Date();
    dt.setMonth(dt.getMonth() - 6);
  } else if (type === '7days') {
    dt = new Date(Date.now() + -7 * 24 * 3600 * 1000);
  } else if (type === 'yesterday') {
    dt = new Date(Date.now() + -1 * 24 * 3600 * 1000);
    //dt.setHours(0);
    //dt.setMinutes(0);
    //dt.setSeconds(0);

    //DB_BRDiff = 0;
  } else if (type === 'today') {
    dt = new Date(Date.now());
    //dt.setHours(0);
    //dt.setMinutes(0);
    //dt.setSeconds(0);

    //DB_BRDiff = 0;
  } else if (type === '24hours') {
    dt = new Date(Date.now() + -1 * 24 * 3600 * 1000);
  } else if (type === '12hours') {
    dt = new Date(Date.now() + -12 * 3600 * 1000);
  } else if (type === 'hour') {
    dt = new Date(Date.now() + -1 * 3600 * 1000);
  } else if (type === '10min') {
    dt = new Date(Date.now() + -1 * 600 * 1000);
  } else if (type === 'custom') {
    dt = new Date(Date.now());
  }

  return formatDate(dt, Timezone_GMT, DB_BRDiff, type);
}

export function formatDateOld(date: Date) {
  return moment(date).format("YYYY-MM-DD HH:mm")
}

export function formatDate(dtActual: Date, Timezone_GMT?, DB_BRDiff?, type?)
{
  let dt = dtActual;
  if (DB_BRDiff != undefined) {
    if (type)
      dt = formatLocalToDBTZDate(dtActual, Timezone_GMT, DB_BRDiff, type);
    else
      dt = formatLocalToDBTZDate(dtActual, Timezone_GMT, DB_BRDiff);
  }
  let myMonth = dt.getMonth() + 1;
  if (myMonth > 12)
    myMonth = 1;
  let myStrMonth = myMonth.toString();
  if (myStrMonth.length == 1)
    myStrMonth = "0" + myStrMonth;

  let myDate = dt.getDate();
  let myStrDate = myDate.toString();
  if (myStrDate.length == 1)
    myStrDate = "0" + myStrDate;

  var newDate = myStrMonth + "/" + myStrDate + "/" + dt.getFullYear() + " " + (dt.toTimeString().split(" "))[0];
  return newDate;
}

//TZ filter when ON - change fetched DB TZ records and search dates also to browser TZ while displaying on screen
export function formatDBTZDateToLocalDate(dt: string, Timezone_GMT, DB_BRDiff, MainFilterID) {
  if (dt.length == 0 || MainFilterID == 0)
    return dt;
  let dtNew = new Date(dt);
  //console.log(formatDate(dtNew))
  if (DB_BRDiff != -500) {
    let currentTime = dtNew.getTime();
    dtNew = new Date(currentTime + DB_BRDiff * 60 * 60 * 1000);//converts DB TZ time to UTC time
  }
  //console.log(formatDate(dtNew))

  return formatDate(dtNew);
}

//
//export function formatUTCToLocalDate(dt: Date) {
  //https://stackoverflow.com/questions/57409178/how-to-convert-datetime-utc-to-local-time-angular
  //let dtNew = new Date(formatDate(dt) + ' UTC'); - ONLY UTC conversion
  //return formatDate(dtNew);
//}

//TZ filter when OFF - change only search dates to DB TZ and display records as it is
export function formatLocalToDBTZDate(dt: Date, Timezone_GMT, DB_BRDiff, type?) {
  //console.log(new Date().toISOString());
  //console.log((new Date()).getTimezoneOffset())
  ////https://stackoverflow.com/questions/10830357/javascript-toisostring-ignores-timezone-offset
  //let tzoffset = (new Date()).getTimezoneOffset(); //UTC offset in minutes
  let dtNew: Date = dt;
  //console.log(DB_BRDiff)
  if (DB_BRDiff != -500) {
    //dtNew.setMinutes(dtNew.getMinutes() + tzoffset);//Converts to UTC
    ////let localISOTime = new Date(Date.now() + tzoffset);
    ////console.log(formatDate(localISOTime))
    //https://www.tutorialspoint.com/How-to-add-2-hours-to-a-JavaScript-Date-object
    let currentTime = dtNew.getTime();
    dtNew = new Date(currentTime - DB_BRDiff * 60 * 60 * 1000);//add hours to match with the DB timezone and thus converted date displayed
  }
  if (type == 'yesterdayTo') {
    dtNew.setHours(23);
    dtNew.setMinutes(59);
    dtNew.setSeconds(59);
  }
  else if (type == 'yesterday' || type == 'today') {
    dtNew.setHours(0);
    dtNew.setMinutes(0);
    dtNew.setSeconds(0);
  }
  //console.log(dtNew)
  return dtNew;
}
